import { styled } from '@mui/material';

import { getTheme } from 'app/components/ThemeProvider/theme';
import { colors } from 'app/components/ThemeProvider/themeColors';

const theme = getTheme();

const FixedBottomAction = styled('div')({
  position: 'fixed',
  bottom: 0,
  left: '341px',
  right: 0,
  width: 'calc(100% - 341px)',
  backgroundColor: colors.base[0],
  borderTop: `1px solid ${colors.base[100]}`,
  padding: '16px 32px',
  display: 'flex',
  justifyContent: 'flex-end',
  zIndex: 1,
  boxSizing: 'border-box',

  [theme.breakpoints.down('md')]: {
    left: 0,
    width: '100%',
    padding: '16px',
  },
});

export default FixedBottomAction;
